// ========== Action Types ==========

// Connections
export const FETCH_CONNECTIONS_REQUEST = 'whatsapp/FETCH_CONNECTIONS_REQUEST';
export const FETCH_CONNECTIONS_SUCCESS = 'whatsapp/FETCH_CONNECTIONS_SUCCESS';
export const FETCH_CONNECTIONS_FAILURE = 'whatsapp/FETCH_CONNECTIONS_FAILURE';

export const INSERT_CONNECTION_REQUEST = 'whatsapp/INSERT_CONNECTION_REQUEST';
export const INSERT_CONNECTION_SUCCESS = 'whatsapp/INSERT_CONNECTION_SUCCESS';
export const INSERT_CONNECTION_FAILURE = 'whatsapp/INSERT_CONNECTION_FAILURE';

export const UPDATE_CONNECTION_REQUEST = 'whatsapp/UPDATE_CONNECTION_REQUEST';
export const UPDATE_CONNECTION_SUCCESS = 'whatsapp/UPDATE_CONNECTION_SUCCESS';
export const UPDATE_CONNECTION_FAILURE = 'whatsapp/UPDATE_CONNECTION_FAILURE';

// Contacts
export const FETCH_CONTACTS_REQUEST = 'whatsapp/FETCH_CONTACTS_REQUEST';
export const FETCH_CONTACTS_SUCCESS = 'whatsapp/FETCH_CONTACTS_SUCCESS';
export const FETCH_CONTACTS_FAILURE = 'whatsapp/FETCH_CONTACTS_FAILURE';

export const INSERT_CONTACT_REQUEST = 'whatsapp/INSERT_CONTACT_REQUEST';
export const INSERT_CONTACT_SUCCESS = 'whatsapp/INSERT_CONTACT_SUCCESS';
export const INSERT_CONTACT_FAILURE = 'whatsapp/INSERT_CONTACT_FAILURE';

export const UPDATE_CONTACT_REQUEST = 'whatsapp/UPDATE_CONTACT_REQUEST';
export const UPDATE_CONTACT_SUCCESS = 'whatsapp/UPDATE_CONTACT_SUCCESS';
export const UPDATE_CONTACT_FAILURE = 'whatsapp/UPDATE_CONTACT_FAILURE';

// Conversations
export const FETCH_CONVERSATIONS_REQUEST = 'whatsapp/FETCH_CONVERSATIONS_REQUEST';
export const FETCH_CONVERSATIONS_SUCCESS = 'whatsapp/FETCH_CONVERSATIONS_SUCCESS';
export const FETCH_CONVERSATIONS_FAILURE = 'whatsapp/FETCH_CONVERSATIONS_FAILURE';

export const INSERT_CONVERSATION_REQUEST = 'whatsapp/INSERT_CONVERSATION_REQUEST';
export const INSERT_CONVERSATION_SUCCESS = 'whatsapp/INSERT_CONVERSATION_SUCCESS';
export const INSERT_CONVERSATION_FAILURE = 'whatsapp/INSERT_CONVERSATION_FAILURE';

export const UPDATE_CONVERSATION_REQUEST = 'whatsapp/UPDATE_CONVERSATION_REQUEST';
export const UPDATE_CONVERSATION_SUCCESS = 'whatsapp/UPDATE_CONVERSATION_SUCCESS';
export const UPDATE_CONVERSATION_FAILURE = 'whatsapp/UPDATE_CONVERSATION_FAILURE';

export const SELECT_CONVERSATION = 'whatsapp/SELECT_CONVERSATION';

// Pinned Conversations (for MiniChat tiles)
export const PIN_CONVERSATION = 'whatsapp/PIN_CONVERSATION';
export const UNPIN_CONVERSATION = 'whatsapp/UNPIN_CONVERSATION';
export const LOAD_PINNED_CONVERSATIONS = 'whatsapp/LOAD_PINNED_CONVERSATIONS';

// Timeline
export const FETCH_TIMELINE_REQUEST = 'whatsapp/FETCH_TIMELINE_REQUEST';
export const FETCH_TIMELINE_SUCCESS = 'whatsapp/FETCH_TIMELINE_SUCCESS';
export const FETCH_TIMELINE_FAILURE = 'whatsapp/FETCH_TIMELINE_FAILURE';
export const LOAD_MORE_TIMELINE_REQUEST = 'whatsapp/LOAD_MORE_TIMELINE_REQUEST';
export const LOAD_MORE_TIMELINE_SUCCESS = 'whatsapp/LOAD_MORE_TIMELINE_SUCCESS';
export const LOAD_MORE_TIMELINE_FAILURE = 'whatsapp/LOAD_MORE_TIMELINE_FAILURE';
export const ADD_MESSAGE_TO_TIMELINE = 'whatsapp/ADD_MESSAGE_TO_TIMELINE';
export const ADD_ALERT_TO_TIMELINE = 'whatsapp/ADD_ALERT_TO_TIMELINE';
export const ADD_CALL_EVENT_TO_TIMELINE = 'whatsapp/ADD_CALL_EVENT_TO_TIMELINE';

// Messages
export const SEND_MESSAGE_REQUEST = 'whatsapp/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'whatsapp/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'whatsapp/SEND_MESSAGE_FAILURE';

export const RECEIVE_MESSAGE = 'whatsapp/RECEIVE_MESSAGE';
export const UPDATE_MESSAGE_STATUS = 'whatsapp/UPDATE_MESSAGE_STATUS';
export const MARK_MESSAGE_READ = 'whatsapp/MARK_MESSAGE_READ';

// Alerts
export const INSERT_CHAT_ALERT_REQUEST = 'whatsapp/INSERT_CHAT_ALERT_REQUEST';
export const INSERT_CHAT_ALERT_SUCCESS = 'whatsapp/INSERT_CHAT_ALERT_SUCCESS';
export const INSERT_CHAT_ALERT_FAILURE = 'whatsapp/INSERT_CHAT_ALERT_FAILURE';

// Call Events
export const INSERT_CALL_EVENT_REQUEST = 'whatsapp/INSERT_CALL_EVENT_REQUEST';
export const INSERT_CALL_EVENT_SUCCESS = 'whatsapp/INSERT_CALL_EVENT_SUCCESS';
export const INSERT_CALL_EVENT_FAILURE = 'whatsapp/INSERT_CALL_EVENT_FAILURE';

// AI Call (CallLog + CallEvent)
export const CREATE_AI_CALL_REQUEST = 'whatsapp/CREATE_AI_CALL_REQUEST';
export const CREATE_AI_CALL_SUCCESS = 'whatsapp/CREATE_AI_CALL_SUCCESS';
export const CREATE_AI_CALL_FAILURE = 'whatsapp/CREATE_AI_CALL_FAILURE';

export const UPDATE_CALL_EVENT_STATUS_REQUEST = 'whatsapp/UPDATE_CALL_EVENT_STATUS_REQUEST';
export const UPDATE_CALL_EVENT_STATUS_SUCCESS = 'whatsapp/UPDATE_CALL_EVENT_STATUS_SUCCESS';
export const UPDATE_CALL_EVENT_STATUS_FAILURE = 'whatsapp/UPDATE_CALL_EVENT_STATUS_FAILURE';

// Messages After Last Event
export const GET_MESSAGES_AFTER_LAST_EVENT_REQUEST =
  'whatsapp/GET_MESSAGES_AFTER_LAST_EVENT_REQUEST';
export const GET_MESSAGES_AFTER_LAST_EVENT_SUCCESS =
  'whatsapp/GET_MESSAGES_AFTER_LAST_EVENT_SUCCESS';
export const GET_MESSAGES_AFTER_LAST_EVENT_FAILURE =
  'whatsapp/GET_MESSAGES_AFTER_LAST_EVENT_FAILURE';

// Templates
export const FETCH_TEMPLATES_REQUEST = 'whatsapp/FETCH_TEMPLATES_REQUEST';
export const FETCH_TEMPLATES_SUCCESS = 'whatsapp/FETCH_TEMPLATES_SUCCESS';
export const FETCH_TEMPLATES_FAILURE = 'whatsapp/FETCH_TEMPLATES_FAILURE';

export const SEND_TEMPLATE_REQUEST = 'whatsapp/SEND_TEMPLATE_REQUEST';
export const SEND_TEMPLATE_SUCCESS = 'whatsapp/SEND_TEMPLATE_SUCCESS';
export const SEND_TEMPLATE_FAILURE = 'whatsapp/SEND_TEMPLATE_FAILURE';

// ========== Action Creators ==========

// Connections
export const fetchConnectionsRequest = (params?: { wabaId?: string; phoneNumber?: string }) => ({
  type: FETCH_CONNECTIONS_REQUEST,
  payload: params
});

export const fetchConnectionsSuccess = (data: any) => ({
  type: FETCH_CONNECTIONS_SUCCESS,
  payload: data
});

export const fetchConnectionsFailure = (error: string) => ({
  type: FETCH_CONNECTIONS_FAILURE,
  payload: error
});

export const insertConnectionRequest = (data: any) => ({
  type: INSERT_CONNECTION_REQUEST,
  payload: data
});

export const insertConnectionSuccess = (data: any) => ({
  type: INSERT_CONNECTION_SUCCESS,
  payload: data
});

export const insertConnectionFailure = (error: string) => ({
  type: INSERT_CONNECTION_FAILURE,
  payload: error
});

export const updateConnectionRequest = (data: any) => ({
  type: UPDATE_CONNECTION_REQUEST,
  payload: data
});

export const updateConnectionSuccess = (data: any) => ({
  type: UPDATE_CONNECTION_SUCCESS,
  payload: data
});

export const updateConnectionFailure = (error: string) => ({
  type: UPDATE_CONNECTION_FAILURE,
  payload: error
});

// Contacts
export const fetchContactsRequest = (phoneNumber: string) => ({
  type: FETCH_CONTACTS_REQUEST,
  payload: { phoneNumber }
});

export const fetchContactsSuccess = (data: any) => ({
  type: FETCH_CONTACTS_SUCCESS,
  payload: data
});

export const fetchContactsFailure = (error: string) => ({
  type: FETCH_CONTACTS_FAILURE,
  payload: error
});

export const insertContactRequest = (data: any) => ({
  type: INSERT_CONTACT_REQUEST,
  payload: data
});

export const insertContactSuccess = (data: any) => ({
  type: INSERT_CONTACT_SUCCESS,
  payload: data
});

export const insertContactFailure = (error: string) => ({
  type: INSERT_CONTACT_FAILURE,
  payload: error
});

export const updateContactRequest = (data: any) => ({
  type: UPDATE_CONTACT_REQUEST,
  payload: data
});

export const updateContactSuccess = (data: any) => ({
  type: UPDATE_CONTACT_SUCCESS,
  payload: data
});

export const updateContactFailure = (error: string) => ({
  type: UPDATE_CONTACT_FAILURE,
  payload: error
});

// Conversations
export const fetchConversationsRequest = (params: {
  conversationsConnectionId?: number;
  recipientId?: string;
}) => ({
  type: FETCH_CONVERSATIONS_REQUEST,
  payload: params
});

export const fetchConversationsSuccess = (data: any) => ({
  type: FETCH_CONVERSATIONS_SUCCESS,
  payload: data
});

export const fetchConversationsFailure = (error: string) => ({
  type: FETCH_CONVERSATIONS_FAILURE,
  payload: error
});

export const insertConversationRequest = (data: any) => ({
  type: INSERT_CONVERSATION_REQUEST,
  payload: data
});

export const insertConversationSuccess = (data: any) => ({
  type: INSERT_CONVERSATION_SUCCESS,
  payload: data
});

export const insertConversationFailure = (error: string) => ({
  type: INSERT_CONVERSATION_FAILURE,
  payload: error
});

export const updateConversationRequest = (data: any) => ({
  type: UPDATE_CONVERSATION_REQUEST,
  payload: data
});

export const updateConversationSuccess = (data: any) => ({
  type: UPDATE_CONVERSATION_SUCCESS,
  payload: data
});

export const updateConversationFailure = (error: string) => ({
  type: UPDATE_CONVERSATION_FAILURE,
  payload: error
});

export const selectConversation = (conversationId: number | null) => ({
  type: SELECT_CONVERSATION,
  payload: conversationId
});

export const pinConversation = (conversationId: string) => ({
  type: PIN_CONVERSATION,
  payload: conversationId
});

export const unpinConversation = (conversationId: string) => ({
  type: UNPIN_CONVERSATION,
  payload: conversationId
});

export const loadPinnedConversations = (conversationIds: string[]) => ({
  type: LOAD_PINNED_CONVERSATIONS,
  payload: conversationIds
});

// Timeline
export const fetchTimelineRequest = (conversationId: number, pageSize = 30) => ({
  type: FETCH_TIMELINE_REQUEST,
  payload: { conversationId, pageSize, pageNumber: 1 }
});

export const fetchTimelineSuccess = (data: any) => ({
  type: FETCH_TIMELINE_SUCCESS,
  payload: data
});

export const fetchTimelineFailure = (error: string) => ({
  type: FETCH_TIMELINE_FAILURE,
  payload: error
});

export const loadMoreTimelineRequest = (
  conversationId: number,
  pageNumber: number,
  pageSize = 30
) => ({
  type: LOAD_MORE_TIMELINE_REQUEST,
  payload: { conversationId, pageSize, pageNumber }
});

export const loadMoreTimelineSuccess = (data: any) => ({
  type: LOAD_MORE_TIMELINE_SUCCESS,
  payload: data
});

export const loadMoreTimelineFailure = (error: string) => ({
  type: LOAD_MORE_TIMELINE_FAILURE,
  payload: error
});

export const addMessageToTimeline = (message: any) => ({
  type: ADD_MESSAGE_TO_TIMELINE,
  payload: message
});

export const addAlertToTimeline = (alert: any) => ({
  type: ADD_ALERT_TO_TIMELINE,
  payload: alert
});

export const addCallEventToTimeline = (callEvent: any) => ({
  type: ADD_CALL_EVENT_TO_TIMELINE,
  payload: callEvent
});

export const updateCallEventStatusRequest = (callEventId: number, status: string) => ({
  type: UPDATE_CALL_EVENT_STATUS_REQUEST,
  payload: { callEventId, status }
});

export const updateCallEventStatusSuccess = (data: any) => ({
  type: UPDATE_CALL_EVENT_STATUS_SUCCESS,
  payload: data
});

export const updateCallEventStatusFailure = (error: string) => ({
  type: UPDATE_CALL_EVENT_STATUS_FAILURE,
  payload: error
});

// Messages
export const sendMessageRequest = (data: {
  conversationId: number;
  conversationsConnectionId: number;
  recipientId: string;
  recipientType: string;
  messageContent?: string;
  mediaType?: string;
  mediaUrl?: string;
  mediaFileName?: string;
  mediaFileTitle?: string;
  replyToMessageId?: string;
  sentByUserId?: number;
  sentAt?: string;
}) => ({
  type: SEND_MESSAGE_REQUEST,
  payload: data
});

export const sendMessageSuccess = (data: any) => ({
  type: SEND_MESSAGE_SUCCESS,
  payload: data
});

export const sendMessageFailure = (error: string) => ({
  type: SEND_MESSAGE_FAILURE,
  payload: error
});

export const receiveMessage = (message: any) => ({
  type: RECEIVE_MESSAGE,
  payload: message
});

export const updateMessageStatus = (data: {
  conversationsOutboundMessageId: number;
  messageStatus: string;
  deliveredAt?: Date;
  readAt?: Date;
  failureReason?: string;
}) => ({
  type: UPDATE_MESSAGE_STATUS,
  payload: data
});

export const markMessageRead = (data: {
  conversationsInboundMessageId: number;
  conversationId: number; // Requerido para notificaciones SignalR
  isRead: boolean;
  status: number;
}) => ({
  type: MARK_MESSAGE_READ,
  payload: data
});

// Alerts
export const insertChatAlertRequest = (data: {
  conversationId: number;
  relatedPhoneNumber: string;
  alertType: string;
  alertTitle: string;
  alertDescription?: string;
  eventMetadata?: string;
  createdAt?: string;
}) => ({
  type: INSERT_CHAT_ALERT_REQUEST,
  payload: data
});

export const insertChatAlertSuccess = (data: any) => ({
  type: INSERT_CHAT_ALERT_SUCCESS,
  payload: data
});

export const insertChatAlertFailure = (error: string) => ({
  type: INSERT_CHAT_ALERT_FAILURE,
  payload: error
});

// Call Events
export const insertCallEventRequest = (data: {
  conversationId: number;
  conversationsCallLogId: number | null;
  eventType: string;
  displayMessage?: string;
  scheduledFor?: string;
  createdAt?: string;
}) => ({
  type: INSERT_CALL_EVENT_REQUEST,
  payload: data
});

export const insertCallEventSuccess = (data: any) => ({
  type: INSERT_CALL_EVENT_SUCCESS,
  payload: data
});

export const insertCallEventFailure = (error: string) => ({
  type: INSERT_CALL_EVENT_FAILURE,
  payload: error
});

// AI Call (CallLog + CallEvent)
export const createAICallRequest = (data: {
  conversationId: number;
  contactPhoneNumber: string;
  callerPhoneNumber: string;
  displayMessage?: string;
  scheduledFor?: string;
}) => ({
  type: CREATE_AI_CALL_REQUEST,
  payload: data
});

export const createAICallSuccess = (data: any) => ({
  type: CREATE_AI_CALL_SUCCESS,
  payload: data
});

export const createAICallFailure = (error: string) => ({
  type: CREATE_AI_CALL_FAILURE,
  payload: error
});

// Messages After Last Event
export const getMessagesAfterLastEventRequest = (data: {
  conversationId: number;
  sortOrder?: 'ASC' | 'DESC';
}) => ({
  type: GET_MESSAGES_AFTER_LAST_EVENT_REQUEST,
  payload: data
});

export const getMessagesAfterLastEventSuccess = (data: any) => ({
  type: GET_MESSAGES_AFTER_LAST_EVENT_SUCCESS,
  payload: data
});

export const getMessagesAfterLastEventFailure = (error: string) => ({
  type: GET_MESSAGES_AFTER_LAST_EVENT_FAILURE,
  payload: error
});

// Templates
export const fetchTemplatesRequest = (data: { wabaId: string; accessToken: string }) => ({
  type: FETCH_TEMPLATES_REQUEST,
  payload: data
});

export const fetchTemplatesSuccess = (templates: any[]) => ({
  type: FETCH_TEMPLATES_SUCCESS,
  payload: templates
});

export const fetchTemplatesFailure = (error: string) => ({
  type: FETCH_TEMPLATES_FAILURE,
  payload: error
});

export const sendTemplateRequest = (data: {
  phoneNumberId: string;
  accessToken: string;
  recipientPhoneNumber: string;
  templateName: string;
  languageCode: string;
  components?: any[];
  conversationId: number;
  template?: any;
}) => ({
  type: SEND_TEMPLATE_REQUEST,
  payload: data
});

export const sendTemplateSuccess = (data: any) => ({
  type: SEND_TEMPLATE_SUCCESS,
  payload: data
});

export const sendTemplateFailure = (error: string) => ({
  type: SEND_TEMPLATE_FAILURE,
  payload: error
});
